/**
 * App Store
 * Global state for app-level data (theme, sidebar, sessions, etc.)
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AppState {
  sidebarOpen: boolean;
  darkMode: boolean;
  // Actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleDarkMode: () => void;
  setDarkMode: (dark: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      darkMode: false,
      selectedSessionId: null,
      sessions: [],

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
      setDarkMode: (dark) => set({ darkMode: dark }),
    }),
    {
      name: 'app-store',
      // Only persist selectedSessionId and UI prefs — sessions list comes from API
      partialize: (state) => ({
        sidebarOpen: state.sidebarOpen,
        darkMode: state.darkMode,
      }),
    }
  )
);

export default useAppStore;